import { LINK_CG_TERMINAL_FORM } from '../form-tcg-types';
import { showToast } from '../../../toasts';

import PostCardGroupTerminal from '../../../../routes/post-card-group-terminal';

/**
 * Formats a list of terminals by id to send to AWS
 * 
 * @param {string} cardGroupId the cardGroupId that the terminals are being associated with.
 */
export const addCardGroupTerminal = async (cardGroupId: string) => {
  const terminalList = document.querySelectorAll<HTMLElement>('[data-termid]');
  const accessList: string[] = [];

  if(terminalList) {
    terminalList.forEach(e => {
      const cardGroupId = e.getAttribute('data-termid')!;
      accessList.push(cardGroupId);
    });
  }

  const awsData = {
    cardGroups: cardGroupId,
    terminalID: accessList.join(',')
  }
  
  PostCardGroupTerminal(awsData)
    .then(response => {    
      showToast('aafp_toast', `${LINK_CG_TERMINAL_FORM.terminalName.value} has been updated`);
    });
}